import { createApi } from '@reduxjs/toolkit/query/react';

import { URL } from 'api/constants';
import { generateUrl } from 'utils/helpers';
import { apiLoaderQuery } from 'store/query';
const tagType = 'Breeds Bitwerx';
import { Utils } from '@gv/triage-components';

export const breedsBitwerxApi = createApi({
  tagTypes: [tagType],
  baseQuery: apiLoaderQuery,
  reducerPath: 'breedsBitwerxApi',
  endpoints: (build) => ({
    list: build.query<any[], any>({
      providesTags: () => [tagType],
      transformResponse: (response: any) => response.data,
      query: (data: any) => ({
        method: 'get',
        url: Utils.Query.addParamsToUrl(
          generateUrl(URL.GET_BITWERX_BREEDS_MASTER_LIST, {
            id: data.id,
          }),
          {
            limit: data.limit,
            offset: data.offset,
          }
        ),
      }),
    }),
  }),
});

export const { useListQuery } = breedsBitwerxApi;
